import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPaper, tokens,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import metaOverrideSet from '../metaOverrideSet';

const useStyles = buildUseStyles('JobIntroStepLayout', () => ({
  paper: {
    '& > div': {
      backgroundColor: tokens.color_oceana_50,
    },
  },
}));

export const JobIntroStepLayout = () => {
  const { resource } = useMetaLayoutContext();
  const classes = useStyles();

  return (
    <PXTextModalWrapper resource={resource}>
      <div className={classes.paper}>
        <FDPaper appearance="flat" color="info" padding={2}>
          <MetaControlField attr="info" metaOverrideSet={metaOverrideSet} />
        </FDPaper>
      </div>
      <MetaControlField attr="description" metaOverrideSet={metaOverrideSet} />
    </PXTextModalWrapper>
  );
};
